<template>
    <div class="cabinet-detail-table">
        <div
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Категория</span>
            </div>
            <div class="cabinet-detail-table__cell">
                <router-link
                    :to="{
                        name: 'SupplierProducts',
                        params: { category_id: product.CategoryID }
                    }"
                    class="cabinet-link"
                >
                    {{ product.category.Name }}
                </router-link>
            </div>
        </div>

        <div
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Вид изделия</span>
            </div>
            <div class="cabinet-detail-table__cell">
                <router-link
                    :to="{
                        name: 'SupplierProducts',
                        params: { type_id: product.TypeID }
                    }"
                    class="cabinet-link"
                >
                    {{ product.type.Name }}
                </router-link>
            </div>
        </div>

        <div
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Бренд</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.brand.BrandName }}
            </div>
        </div>

        <div
            v-if="product.CollectionID"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Коллекция</span>
            </div>
            <div class="cabinet-detail-table__cell">
                <router-link
                    :to="{
                        name: 'SupplierProducts',
                        params: { collection_id: product.CollectionID }
                    }"
                    class="cabinet-link"
                >
                    {{ product.product_collection.Name }}
                </router-link>
            </div>
        </div>

        <div
            v-if="product.Article"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Артикул</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.Article }}
            </div>
        </div>

        <div
            v-if="product.purposes.length"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Назначение</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.purposes.map(purposes => purposes.Name).join(', ') }}
            </div>
        </div>

        <div
            v-if="product.Gender"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Для кого</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.gender_title }}
            </div>
        </div>

        <div
            v-if="product.Size && !isWatchCategory"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Доступные размеры</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.Size }}
            </div>
        </div>

        <div
            v-if="product.Weight && !isWatchCategory"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Вес</span>
            </div>
            <div class="cabinet-detail-table__cell">{{ product.Weight }} г</div>
        </div>

        <div
            class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Материал</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.materials[0].Name }}
            </div>
        </div>

        <div
            v-if="productColors.length"
            class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Цвет металла</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ productColors.join(', ') }}
            </div>
        </div>

        <div
            v-if="product.materials[0].pivot.Fineness"
            class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Проба</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.materials[0].pivot.Fineness }}
            </div>
        </div>

        <template v-if="isWatchCategory && product.item_watch">
            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Средний вес драгметалла
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.PreciousMetalWeight || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Форма корпуса
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{
                        product.item_watch.case_shape
                            ? product.item_watch.case_shape.Name
                            : '—'
                    }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Размер корпуса
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.CaseSize || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Высота корпуса
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{
                        product.item_watch.CaseHeight
                            ? `${product.item_watch.CaseHeight} мм`
                            : '—'
                    }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Механизм
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.Mechanism || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Тип механизма
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.MechanismType || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Дополнительные функции
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.MechanismFeatures || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Функции
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.Features || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Ширина ремешка
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{
                        product.item_watch.BraceletWidth
                            ? `${product.item_watch.BraceletWidth} мм`
                            : '—'
                    }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Материал ремешка
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.BraceletMaterial || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Стекло
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.GlassType || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Элемент питания
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.Battery || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Вид циферблата
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.DialType || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Цвет циферблата
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.DialColor || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Водостойкость
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.WaterResistance || '—' }}
                </div>
            </div>
        </template>

        <template v-if="!isWatchCategory">
            <div
                v-if="product.technology"
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key"
                        >Технология изготовления</span
                    >
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.technology.Name }}
                </div>
            </div>

            <div
                v-if="product.decor.length"
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Тип декора</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.decor.map(decor => decor.Name).join(', ') }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DetailSpecifications',
    computed: {
        ...mapState('supplierProducts', ['product']),
        productColors() {
            return this.product.colors.map(color => color.Name)
        },
        isWatchCategory() {
            return this.product.CategoryID === 5 //Часы
        }
    }
}
</script>
